var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_2180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.20837 7.18358C3.08674 6.63568 3.10542 6.06595 3.26267 5.52719C3.41992 4.98844 3.71066 4.49811 4.10793 4.10168C4.5052 3.70524 4.99613 3.41553 5.53521 3.25941C6.07429 3.10328 6.64407 3.0858 7.19171 3.20858C7.49313 2.73716 7.90837 2.34921 8.39916 2.08048C8.88995 1.81175 9.44049 1.6709 10 1.6709C10.5596 1.6709 11.1101 1.81175 11.6009 2.08048C12.0917 2.34921 12.5069 2.73716 12.8084 3.20858C13.3568 3.08526 13.9276 3.10267 14.4675 3.25917C15.0075 3.41568 15.4991 3.70619 15.8966 4.10371C16.2941 4.50122 16.5846 4.9928 16.7411 5.53275C16.8976 6.07269 16.915 6.64344 16.7917 7.19191C17.2631 7.49334 17.6511 7.90858 17.9198 8.39937C18.1885 8.89016 18.3294 9.4407 18.3294 10.0002C18.3294 10.5598 18.1885 11.1103 17.9198 11.6011C17.6511 12.0919 17.2631 12.5072 16.7917 12.8086C16.9145 13.3562 16.897 13.926 16.7409 14.4651C16.5848 15.0042 16.295 15.4951 15.8986 15.8924C15.5022 16.2896 15.0118 16.5804 14.4731 16.7376C13.9343 16.8949 13.3646 16.9135 12.8167 16.7919C12.5157 17.2651 12.1001 17.6547 11.6085 17.9247C11.1168 18.1946 10.5651 18.3361 10.0042 18.3361C9.44335 18.3361 8.89156 18.1946 8.39993 17.9247C7.90831 17.6547 7.49274 17.2651 7.19171 16.7919C6.64407 16.9147 6.07429 16.8972 5.53521 16.7411C4.99613 16.585 4.5052 16.2952 4.10793 15.8988C3.71066 15.5024 3.41992 15.012 3.26267 14.4733C3.10542 13.9345 3.08674 13.3648 3.20837 12.8169C2.73334 12.5163 2.34205 12.1004 2.07091 11.6079C1.79977 11.1155 1.65759 10.5624 1.65759 10.0002C1.65759 9.43807 1.79977 8.88503 2.07091 8.39257C2.34205 7.9001 2.73334 7.48421 3.20837 7.18358Z",
    stroke: "#282D38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66699V10.0003",
    stroke: "#282D38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.333H10.0083",
    stroke: "#282D38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_2180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue);
export default __webpack_public_path__ + "static/media/issue.e1089461f0923d0f5429c5700e3f931e.svg";
export { ForwardRef as ReactComponent };